export default __webpack_public_path__ + "static/media/classroomImg1.9b50ee3d.svg";